import { useCityById } from '@entities/cities/hooks'
import { useChangeCity, useShipment } from '@entities/shipment/model'
import { useStoreMap } from 'effector-react/compat'
import { $cities } from '@entities/cities/model'
import ComboBox from '@shared/ComboBox/ComboBox'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    border: 1px solid ${ThemeColors.accentGreen};
    border-radius: 5px;
`

interface CitySectionCbDesktopProps {
    change: (id: number) => void
    cityId: number
}

export function CitySectionCbDesktop({ change, cityId }: CitySectionCbDesktopProps) {
    // const change = useChangeCity()
    // const shipment = useShipment()
    const city = useCityById(cityId)

    const citiesMapped = useStoreMap($cities, (c) =>
        c.map((x) => ({
            ...x,
            text: x.title
        }))
    )

    return (
        <Container>
            <ComboBox
                name="city"
                items={citiesMapped}
                selectItemId={city?.id}
                selectHandler={change}
                placeholder={city?.title}
            />
        </Container>
    )
}
